import type { SxProps, Theme } from '@mui/material';

export const documentsContentSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 560,
  mx: 'auto',
};

export const documentsActionButtonSx: SxProps<Theme> = {
  maxWidth: 360,
  width: '100%',
  alignSelf: 'center',
};
